import { render, staticRenderFns } from "./BchProductBilling.vue?vue&type=template&id=16d5a7f6&scoped=true"
import script from "./BchProductBilling.vue?vue&type=script&lang=js"
export * from "./BchProductBilling.vue?vue&type=script&lang=js"
import style0 from "./BchProductBilling.vue?vue&type=style&index=0&id=16d5a7f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d5a7f6",
  null
  
)

export default component.exports